@switch (modalType) {
  @case ('right-panel') {
    <app-side-panel-modal [modalWindowWrapper]="modalWindowWrapper" (closeModal)="closeModal()"></app-side-panel-modal>
  }

  @default {
    <app-central-modal [modalWindowWrapper]="modalWindowWrapper" (closeModal)="closeModal()"></app-central-modal>
  }
}
